<template>
  <div class="container-fluid mt-4">
    <CRow class="pr-2">
      <!-- MAIN -->
      <CCol col="10" xl="10" class="p-0">
        <!-- Header -->
        <CCard class="mb-2">
          <CCardBody>
            <CRow class="align-items-center">
              <CCol sm="8">
                <h4 class="mb-1">Včelári – nástenka</h4>
                <div class="small text-muted">Prehľad podľa kraja, okresu, obce a typov medu (bez objemov)</div>
              </CCol>
              <CCol sm="4" class="text-right d-none d-md-block">
                <a-button @click="downloadCSV">Stiahnuť CSV (výber)</a-button>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- LOADER WRAPPER -->
        <a-spin :spinning="spinning" :tip="spinTip">
          <!-- KPIs -->
          <a-row :gutter="12" class="mb-0">
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody>
                <a-card>
                <div class="kpi__label">Včelári</div>
                <div class="kpi__value">{{ kpis.totalBeekeepers }}</div>
                </a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody><a-card>
                <div class="kpi__label">Kraje</div>
                <div class="kpi__value">{{ kpis.totalRegions }}</div></a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody><a-card>
                <div class="kpi__label">Okresy</div>
                <div class="kpi__value">{{ kpis.totalCounties }}</div></a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody><a-card>
                <div class="kpi__label">Obce</div>
                <div class="kpi__value">{{ kpis.totalCities }}</div></a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody><a-card>
                <div class="kpi__label">Typy medu</div>
                <div class="kpi__value">{{ kpis.totalHoneyTypes }}</div></a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="12" :md="6" :xl="4">
              <CCard class="kpi-card"><CCardBody><a-card>
                <div class="kpi__label">Súčet včelstiev</div>
                <div class="kpi__value">{{ kpis.totalBeeColonies }}</div></a-card>
              </CCardBody></CCard>
            </a-col>
          </a-row>

          <!-- Charts -->
          <a-row :gutter="12" class="mb-1">
            <a-col :xs="24" :lg="12">
              <CCard><CCardBody><a-card class="chart-card">
  <div class="chart-wrap">
                <h6 class="mb-3">Podiel typov medu (podľa počtu včelárov)</h6>
                <div class="chart" ref="pieRef"></div>
              </div>
            </a-card>
              </CCardBody></CCard>
            </a-col>
            <a-col :xs="24" :lg="12">
              <CCard><CCardBody><a-card class="chart-card">
  <div class="chart-wrap">
                <h6 class="mb-3">Top okresy podľa počtu včelárov</h6>
                <div class="chart" ref="barTopCountiesRef"></div>
              </div>
            </a-card>
              </CCardBody></CCard>
            </a-col>
          </a-row>

          <a-row :gutter="12" class="mb-1">
            <a-col :xs="24">
              <CCard><CCardBody><a-card class="chart-card">
  <div class="chart-wrap">
                <h6 class="mb-3">Okresy × typy medu (počty včelárov)</h6>
                <div class="chart large" ref="stackedRef"></div>
              </div>
              </a-card>
              </CCardBody></CCard>
            </a-col>
          </a-row>

          <!-- Tables -->
<a-row :gutter="12" class="mb-4">
  <a-col :xs="24">
    <CCard><CCardBody>
      <a-card>
      <h6 class="mb-3">Súhrn podľa okresu</h6>
      <a-table
        :columns="districtColumns"
        :data-source="districtTableData"
        :loading="loading"
        row-key="_key"
        :pagination="{ pageSize: 10 }"
        size="small"
      /></a-card>
    </CCardBody></CCard>
  </a-col>
</a-row>

<a-row :gutter="12" class="mb-4">
  <a-col :xs="24">
    <CCard><CCardBody>
      <a-card>
      <h6 class="mb-3">Súhrn podľa obce</h6>
      <a-table
        :columns="cityColumns"
        :data-source="cityTableData"
        :loading="loading"
        row-key="_key"
        :pagination="{ pageSize: 10 }"
        size="small"
      /></a-card>
    </CCardBody></CCard>
  </a-col>
</a-row>

          <a-empty v-if="!spinning && !beekeepers.length" description="Žiadne dáta" />
        </a-spin>
      </CCol>

      <!-- FILTER SIDE (pravý panel) -->
      <CCol col="2" xl="2" class="pl-0">
        <CCard class="p-0 pt-2 filter-side">
          <CCardBody>
            <a-card
              class="filter-card p-2"
              :class="{ 'filter-active': isFilterActive }"
              :body-style="{ padding: 0 }"
            >
              <span slot="title">Filter</span>
              <span slot="extra">
                <a-button size="small" @click="applyFilters">Filtrovať</a-button>
              </span>

              <div class="p-2">
                <a-form layout="vertical">
                  <a-form-item label="Kraj">
                    <a-select v-model="filters.regions" mode="multiple" allow-clear
                              :max-tag-count="2" :options="regionOptions" placeholder="Vyberte kraj" />
                  </a-form-item>

                  <a-form-item label="Okres">
                    <a-select v-model="filters.counties" mode="multiple" allow-clear
                              :max-tag-count="2" :options="countyOptions" placeholder="Vyberte okres" />
                  </a-form-item>

                  <a-form-item label="Obec">
                    <a-select v-model="filters.cities" mode="multiple" allow-clear
                              :max-tag-count="2" :options="cityOptions" placeholder="Vyberte obec" />
                  </a-form-item>

                  <a-form-item label="Typy medu">
                    <a-select v-model="filters.honeyTypes" mode="multiple" allow-clear
                              :max-tag-count="2" :options="honeyTypeOptions" placeholder="Vyberte typy medu" />
                  </a-form-item>

                  <a-form-item label="Základná organizácia (ZO)">
                    <a-select v-model="filters.zo" mode="multiple" allow-clear
                              :max-tag-count="2" :options="zoOptions" placeholder="Vyberte ZO" />
                  </a-form-item>

                  <a-form-item label="Typ včelára">
                    <a-select v-model="filters.types" mode="multiple" allow-clear
                              :max-tag-count="2" :options="typeOptions" placeholder="Hobby / Profi …" />
                  </a-form-item>

                  <a-form-item label="Hľadať (meno, farma, obec)">
                    <a-input v-model="filters.search" allow-clear placeholder="Zadajte hľadaný text" />
                  </a-form-item>

                  <div class="d-flex justify-content-between mt-2">
                    <a-button  class="mb-3 mt-3 float-left" type="danger" @click="resetFilters" v-if="isFilterActive">Vymazať</a-button>
                      <a-button class="mb-3 mt-3 float-right" type="primary"  @click="applyFilters">Filtrovať</a-button>


                  </div>
                </a-form>
              </div>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { dataService } from '../_services'
import { Select, Input, Button, Table, Form, Row, Col, Empty, Spin } from 'ant-design-vue'

export default {
  name: 'DashboardBee',
  components: {
    'a-select': Select,
    'a-input': Input,
    'a-button': Button,
    'a-table': Table,
    'a-form': Form,
    'a-form-item': Form.Item,
    'a-row': Row,
    'a-col': Col,
    'a-empty': Empty,
    'a-spin': Spin
  },
  data() {
    return {
      loading: false,
      loadingMeta: false,
      beekeepers: [],

      taxo: { zo: {}, city: {}, county: {}, kraj: {}, type: {}, honeytype: {} },

      filters: { regions: [], counties: [], cities: [], honeyTypes: [], zo: [], types: [], search: '' },
 pageSize: 3000,
    pagesLoaded: 0,
    spinTip: 'Načítavam údaje…',
      regionOptions: [],
      countyOptions: [],
      cityOptions: [],
      honeyTypeOptions: [],
      zoOptions: [],
      typeOptions: [],

      selectedCounty: null,

      _pie: null,
      _barTop: null,
      _stacked: null
    }
  },
  computed: {
     spinning(){ return this.loading || this.loadingMeta },
    isFilterActive() {
      const f = this.filters
      return !!(
        (f.search && f.search.trim()) ||
        f.regions.length || f.counties.length || f.cities.length ||
        f.honeyTypes.length || f.zo.length || f.types.length
      )
    },
    filtered() {
      const q = (this.filters.search || '').trim().toLowerCase()
      const { regions, counties, cities, honeyTypes, zo, types } = this.filters

      return this.beekeepers.filter(b => {
        const okRegion = !regions.length || regions.includes(b.kraj)
        const okCounty = !counties.length || counties.includes(b.county)
        const okCity = !cities.length || cities.includes(b.city)
        const okHoney = !honeyTypes.length || b.honey_types.some(ht => honeyTypes.includes(ht))
        const okZO = !zo.length || (b.zo && zo.includes(b.zo))
        const okType = !types.length || (b.type && types.includes(b.type))
        const okSearch = !q ||
          (b.fullname && b.fullname.toLowerCase().includes(q)) ||
          (b.farmname && b.farmname.toLowerCase().includes(q)) ||
          (b.city && b.city.toLowerCase().includes(q))
        return okRegion && okCounty && okCity && okHoney && okZO && okType && okSearch
      })
    },
    kpis() {
      const setRegions = new Set(this.filtered.map(b => b.kraj).filter(Boolean))
      const setCounties = new Set(this.filtered.map(b => b.county).filter(Boolean))
      const setCities = new Set(this.filtered.map(b => b.city).filter(Boolean))
      const setHoney = new Set(this.filtered.flatMap(b => b.honey_types))
      const totalBeeColonies = this.filtered.reduce((s,b) => s + (Number.isFinite(b.beenumber) ? b.beenumber : 0), 0)
      return {
        totalBeekeepers: this.filtered.length,
        totalRegions: setRegions.size,
        totalCounties: setCounties.size,
        totalCities: setCities.size,
        totalHoneyTypes: setHoney.size,
        totalBeeColonies
      }
    },

    // === Tables ===
    districtColumns() {
      const types = this.allHoneyTypesSorted()
      const base = [
        { title: 'Okres', dataIndex: 'county', key: 'county', fixed: 'left' },
        { title: 'Spolu', dataIndex: 'total', key: 'total', sorter: (a,b) => a.total - b.total }
      ]
      const dyn = types.map(t => ({ title: this.shortType(t), dataIndex: this._typeKey(t), key: this._typeKey(t) }))
      return [...base, ...dyn]
    },
    cityColumns() {
  return [
    { title: 'Obec', dataIndex: 'city', key: 'city', fixed: 'left' },
    { title: 'Včelári', dataIndex: 'cnt', key: 'cnt', sorter: (a,b) => a.cnt - b.cnt, width: 120 },
    { title: 'Včelstvá', dataIndex: 'colonies', key: 'colonies', sorter: (a,b) => a.colonies - b.colonies, align: 'right', width: 140 }
  ]
},
cityTableData() {
  const group = this.groupBy(this.filtered, b => b.city || '—')
  const rows = Object.keys(group).map(city => {
    const list = group[city]
    const cnt = list.length
    const colonies = list.reduce((s, b) => s + (Number.isFinite(b.beenumber) ? b.beenumber : 0), 0)
    return { _key: `city-${city}`, city, cnt, colonies }
  })
  // primárne podľa počtu včelárov, sekundárne podľa včelstiev
  return rows.sort((a,b) => (b.cnt - a.cnt) || (b.colonies - a.colonies))
},
    districtTableData() {
      const types = this.allHoneyTypesSorted()
      const group = this.groupBy(this.filtered, b => b.county || '—')
      const rows = Object.keys(group).map(county => {
        const beeks = group[county]
        const base = { _key: `c-${county}`, county, total: beeks.length }
        types.forEach(t => { base[this._typeKey(t)] = beeks.filter(b => b.honey_types.includes(t)).length })
        return base
      })
      return rows.sort((a,b) => b.total - a.total)
    },

    beekeeperColumns() {
      return [
        { title: 'Včelár', key: 'fullname', dataIndex: 'fullname', ellipsis: true },
        { title: 'Farma', key: 'farmname', dataIndex: 'farmname', ellipsis: true },
        { title: 'Obec', key: 'city', dataIndex: 'city' },
        { title: 'Okres', key: 'county', dataIndex: 'county' },
        { title: 'Kraj', key: 'kraj', dataIndex: 'kraj' },
        { title: 'Typy medu', key: 'honey', dataIndex: 'honey_str', ellipsis: true },
        { title: 'Včelstvá', key: 'beenumber', dataIndex: 'beenumber', align: 'right', width: 100 },
        { title: 'Kontakt', key: 'contact', dataIndex: 'contact', ellipsis: true }
      ]
    },
    beekeeperTableData() {
      const data = (this.selectedCounty ? this.filtered.filter(b => b.county === this.selectedCounty) : this.filtered)
      return data.map(b => ({
        id: b.id,
        fullname: b.fullname || b.farmname || '—',
        farmname: b.farmname || '—',
        city: b.city || '—',
        county: b.county || '—',
        kraj: b.kraj || '—',
        honey: b.honey_types,
        honey_str: b.honey_types.map(this.shortType).join(' | '),
        beenumber: Number.isFinite(b.beenumber) ? b.beenumber : null,
        contact: [b.email, b.phone].filter(Boolean).join(' / ')
      }))
    },
    beekeeperTableTitle() { return this.selectedCounty ? `okres ${this.selectedCounty}` : 'všetky okresy' }
  },
  async mounted() {
    this.loadingMeta = true
    try {
      await this.fetchTaxonomies()
    } finally {
      this.loadingMeta = false
    }
    await this.fetchBeekeepers()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.disposeCharts()
  },
  watch: {
    filtered: { deep: true, handler() { this.$nextTick(this.renderAllCharts) } }
  },
  methods: {
    // === Taxonomy maps ===
 async fetchTaxonomies () {
  // axiosFetch u teba vracia priamo JSON (nie AxiosResponse)
  const cfg = await dataService.axiosFetch('contenttype/beekeeper')
  // buď je to rovno na koreňi, alebo fallbackni na data.*
  const root = cfg && (cfg.options || cfg.fields) ? cfg
              : (cfg && cfg.data && (cfg.data.options || cfg.data.fields) ? cfg.data
              : (cfg && cfg.data && cfg.data.data ? cfg.data.data : {}))

  const fields  = root.fields  || []
  const options = root.options || {}

  // pomocník: nájdi field podľa slug a vráť jeho options pole
  const bySlug = (slug, ...aliases) => {
    const wanted = [slug, ...aliases].filter(Boolean)
    const f = fields.find(x => wanted.includes(x.slug))
    if (!f) return []
    const id = String(f.id)
    return options[id] || options[+id] || []
  }

  const mapFrom = (arr) => {
    const m = {}
    ;(arr || []).forEach(o => { m[String(o.value)] = o.label })
    return m
  }

  // naviazanie čisto cez slugs (pridávam aliasy pre prípad drobných odchýlok)
  this.taxo.zo        = mapFrom(bySlug('zo', 'zalozna_organizacia'))
  this.taxo.city      = mapFrom(bySlug('city', 'obec'))
  this.taxo.county    = mapFrom(bySlug('county', 'okres'))
  this.taxo.kraj      = mapFrom(bySlug('kraj', 'region'))
  this.taxo.type      = mapFrom(bySlug('type', 'typ'))
  this.taxo.honeytype = mapFrom(bySlug('honeytype', 'honey_type', 'typy_medu'))
},
calcLabelWidth(cnt, el) {
  // približná šírka jedného labelu podľa dostupnej šírky grafu
  const w = el ? el.clientWidth : 600
  const per = w / Math.max(cnt, 1)
  // drž sa rozumnej šírky – nech sa text zvládne zalomiť
  return Math.max(60, Math.min(120, Math.floor(per) - 8))
},
    toIdList(v){
      const pick = (x)=>{
        if (x == null) return null
        if (typeof x === 'number' || typeof x === 'string') return String(x)
        if (typeof x === 'object') return String(x.value || x.id || x.tid || x.term_id || x.target_id || x.key || x.slug || '')
        return null
      }
      if (Array.isArray(v)) return v.map(pick).filter(Boolean)
      const one = pick(v); return one ? [one] : []
    },
    getTaxoLabel(field, value, multi=false){
      const map = this.taxo[field] || {}
      const ids = this.toIdList(value)
      const labels = ids.map(id => map[id] || (typeof value === 'object' && value.label) || String(id)).filter(Boolean)
      return multi ? labels : (labels[0] || '')
    },

    async fetchBeekeepers() {
  this.loading = true
  this.spinTip = 'Načítavam údaje…'
  this.pagesLoaded = 0
  this.beekeepers = []  // čistý štart

  const parseBatch = (res) => {
    const d = res && res.data
    let arr = Array.isArray(d) ? d : (d && d.data) || []
    // niektoré endpointy na konci posielajú total ako číslo – ošetri:
    if (arr.length && typeof arr[arr.length - 1] === 'number') arr = arr.slice(0, -1)
    return Array.isArray(arr) ? arr : []
  }

  try {
    let page = 0
    while (true) {
      // načítaj ďalšiu stránku
      const res = await dataService.axiosPost(`content/beekeeper/true/${page}/${this.pageSize}`)
      const batch = parseBatch(res)
      if (!batch.length) break

      // inkrementálne spracovanie a render
      const normalized = batch.map(this.normalizeBeekeeper).filter(Boolean)
      this.beekeepers = this.beekeepers.concat(normalized)

      // po prvej stránke priprav options a grafy, ostatné stránky budú už len dopĺňať
      if (page === 0) this.prepareOptions()

      this.pagesLoaded += 1
      this.spinTip = `Načítavam údaje… (${this.beekeepers.length} záznamov)`

      // priebežný re-render grafov nech má používateľ niečo hneď
      this.$nextTick(this.renderAllCharts)

      // posledná stránka?
      if (batch.length < this.pageSize) break
      page += 1
    }

    // finálne prekreslenie
    this.$nextTick(this.renderAllCharts)
  } catch (e) {
    console.error(e)
    this.$message && this.$message.error('Nepodarilo sa načítať včelárov')
  } finally {
    this.loading = false
    this.spinTip = 'Načítané'
  }
},

    // bezpečné parsovanie JSON stringu s ID
    maybeParseJSONArray(s) {
      if (typeof s !== 'string') return null
      const t = s.trim()
      if (!t.startsWith('[') || !t.endsWith(']')) return null
      try {
        const arr = JSON.parse(t)
        return Array.isArray(arr) ? arr : null
      } catch (e) { return null }
    },
    getHoneyTypesFromRecord(rec) {
      if (Array.isArray(rec.honeytype_datas) && rec.honeytype_datas.length) {
        return rec.honeytype_datas.map(x => (x && (x.title || x.label)) || '').filter(Boolean)
      }
      if (typeof rec.honeytype_data === 'string' && rec.honeytype_data.trim()) {
        return rec.honeytype_data.split(',').map(s => s.trim()).filter(Boolean)
      }
      if (typeof rec.honeytype === 'string') {
        const ids = this.maybeParseJSONArray(rec.honeytype)
        if (ids) {
          return ids.map(id => this.taxo.honeytype[String(id)] || String(id)).filter(Boolean)
        }
      }
      if (Array.isArray(rec.honeytype)) {
        return rec.honeytype.map(v => {
          const id = (v && (v.value || v.id || v)) + ''
          return this.taxo.honeytype[id] || this.pickLabel(v) || id
        }).filter(Boolean)
      }
      return []
    },

    normalizeBeekeeper(it) {
      const id = it.id || it.nid || it.beekeeper_id || it.regnumber || it.farmcode
      const fname = (it.name || '').toString().trim()
      const sname = (it.title || '').toString().trim()
      const tb = (it.titlebefore || '').toString().trim()
      const ta = (it.aftertitle || '').toString().trim()
      const fullname = [tb, fname, sname].filter(Boolean).join(' ') + (ta ? `, ${ta}` : '')

      const farmname = it.farmname || ''
      const city  = this.getTaxoLabel('city', it.city)
      const county= this.getTaxoLabel('county', it.county)
      const kraj  = this.getTaxoLabel('kraj', it.kraj)
      const zo    = this.getTaxoLabel('zo', it.zo)
      const type  = this.getTaxoLabel('type', it.type)
      const email = it.email || ''
      const phone = it.phone || ''
      const beenumber = this.asInt(it.beenumber)

      let types = this.getHoneyTypesFromRecord(it)
      types = Array.from(new Set(types.map(this.cleanType))).filter(Boolean)

      if (!id) return null
      return { id, fullname, farmname, city, county, kraj, zo, type, email, phone, beenumber, honey_types: types }
    },

    splitTypes(s){ return String(s).split(/[,;\|\/]|\s[-–]\s/g).map(x => x.trim()).filter(Boolean) },
    cleanType(s){ return String(s).replace(/\s+–\s+/g, ' – ').replace(/\s+-\s+/g, ' – ').trim() },
    asInt(x){ const n=parseInt(x,10); return Number.isFinite(n) ? n : null },

    // === options to selects
    prepareOptions(){
      const regions = Array.from(new Set(this.beekeepers.map(b => b.kraj).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'sk'))
      const counties = Array.from(new Set(this.beekeepers.map(b => b.county).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'sk'))
      const cities = Array.from(new Set(this.beekeepers.map(b => b.city).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'sk'))
      const types = this.allHoneyTypesSorted()
      const zos = Array.from(new Set(this.beekeepers.map(b => b.zo).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'sk'))
      const btypes = Array.from(new Set(this.beekeepers.map(b => b.type).filter(Boolean))).sort((a,b)=>a.localeCompare(b,'sk'))

      this.regionOptions = regions.map(x => ({label:x, value:x}))
      this.countyOptions = counties.map(x => ({label:x, value:x}))
      this.cityOptions = cities.map(x => ({label:x, value:x}))
      this.honeyTypeOptions = types.map(x => ({label:this.shortType(x), value:x}))
      this.zoOptions = zos.map(x => ({label:x, value:x}))
      this.typeOptions = btypes.map(x => ({label:x, value:x}))
    },

    allHoneyTypesSorted(){ return Array.from(new Set(this.beekeepers.flatMap(b => b.honey_types))).sort((a,b)=>a.localeCompare(b,'sk')) },
    _typeKey(t){ return `t_${t.replace(/\s+/g,'_').toLowerCase()}` },

    // === label helpers (skracovanie / zalamovanie) ===
    shortType(s) {
      if (!s) return ''
      let t = String(s)
        .replace(/^Kvetový\s*[–-]\s*/i, '')   // „Kvetový – Agátový“ → „Agátový“
        .replace(/^Kvetový\s*/i, 'Kvetový ')  // „Kvetový“ necháme
        .replace(/\s*\(medovica-kvet\)/i, ' (mix)')
      return t
    },
    wrapLabel(str, max = 12) {
      const s = String(str)
      if (s.length <= max) return s
      const parts = []
      let i = 0
      while (i < s.length) { parts.push(s.slice(i, i + max)); i += max }
      return parts.join('\n')
    },

    // === Charts ===
    renderAllCharts(){ this.renderPie(); this.renderTopCounties(); this.renderStacked(); },
    disposeCharts(){ if(this._pie) this._pie.dispose(); if(this._barTop) this._barTop.dispose(); if(this._stacked) this._stacked.dispose(); this._pie=this._barTop=this._stacked=null },
    handleResize(){ this._pie && this._pie.resize(); this._barTop && this._barTop.resize(); this._stacked && this._stacked.resize(); },

    renderPie(){
      const el=this.$refs.pieRef; if(!el) return;
      const data=this.pieSeriesData();
      const wrap = this.wrapLabel, short = this.shortType
      this._pie = this._pie || echarts.init(el);
      this._pie.setOption({
        tooltip:{ trigger:'item', formatter: p => `${p.name}<br/>Včelári: ${p.value} (${p.percent}%)` },
        legend:{ type:'scroll', bottom:0, formatter: n => short(n) },
        series:[{
          type:'pie', radius:['35%','70%'],
          label:{ show:true, formatter: p => `${short(p.name)}\n${p.percent}%` },
          data
        }]
      })
    },
    pieSeriesData(){
      const counter={}; this.filtered.forEach(b => b.honey_types.forEach(t => { counter[t]=(counter[t]||0)+1 }));
      return Object.keys(counter).map(k=>({name:k, value:counter[k]})).sort((a,b)=>b.value-a.value)
    },

    renderTopCounties(limit = 10) {
  const el = this.$refs.barTopCountiesRef
  if (!el) return

  const group = this.groupBy(this.filtered, b => b.county || '—')
  let rows = Object.keys(group).map(k => ({ county: k, cnt: group[k].length }))
  rows = rows.sort((a, b) => b.cnt - a.cnt).slice(0, limit)

  const x = rows.map(r => r.county)
  const y = rows.map(r => r.cnt)

  const labelW = this.calcLabelWidth(x.length, el)

  this._barTop = this._barTop || echarts.init(el)
  this._barTop.setOption({
    tooltip: { trigger: 'axis' },
    grid: { left: 40, right: 20, top: 10, bottom: 90 }, // nech má text miesto
    xAxis: {
      type: 'category',
      data: x,
      axisLabel: {
        interval: 0,
        rotate: 32,          // šikmé vypísanie
        fontSize: 11,        // menší font
        width: labelW,       // pevná šírka na zalomenie
        overflow: 'break',   // zalamovanie
        lineHeight: 14
      }
    },
    yAxis: { type: 'value' },
    series: [{ type: 'bar', name: 'Včelári', data: y }]
  })

  this._barTop.off('click')
  this._barTop.on('click', p => { this.selectedCounty = p.name })
},

    renderStacked() {
  const el = this.$refs.stackedRef
  if (!el) return

  const types = this.allHoneyTypesSorted()
  const group = this.groupBy(this.filtered, b => b.county || '—')
  const counties = Object.keys(group).sort((a, b) => group[b].length - group[a].length)
  const series = types.map(t => ({
    name: this.shortType(t),
    type: 'bar',
    stack: 'total',
    data: counties.map(c => group[c].filter(b => b.honey_types.includes(t)).length)
  }))

  const labelW = this.calcLabelWidth(counties.length, el)

  this._stacked = this._stacked || echarts.init(el)
  this._stacked.setOption({
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    legend: { type: 'scroll', bottom: 0 },
    grid: { left: 40, right: 20, top: 10, bottom: 80 },
    xAxis: {
      type: 'category',
      data: counties,
      axisLabel: {
        interval: 0,
        rotate: 32,
        fontSize: 11,
        width: labelW,
        overflow: 'break',
        lineHeight: 14
      }
    },
    yAxis: { type: 'value' },
    series
  })
},

    // === Tables interactions ===
    onCountyRowClick(record){ this.selectedCounty = record.county },

    // === Utils ===
    groupBy(arr, keyGetter){ return arr.reduce((a,x)=>{const k=keyGetter(x); (a[k]=a[k]||[]).push(x); return a}, {}) },

    // === Actions ===
    applyFilters(){ this.$nextTick(this.renderAllCharts) },
    resetFilters(){
      this.filters={ regions:[], counties:[], cities:[], honeyTypes:[], zo:[], types:[], search:'' };
      this.selectedCounty=null; this.$nextTick(this.renderAllCharts)
    },

    downloadCSV(){
      const rows = this.filtered.map(b => ({
        id: b.id, vcelar: b.fullname, farma: b.farmname, kraj: b.kraj, okres: b.county, obec: b.city,
        typy_medu: b.honey_types.join(' | '), vcelstva: Number.isFinite(b.beenumber) ? b.beenumber : '',
        email: b.email || '', telefon: b.phone || ''
      }))
      const header = Object.keys(rows[0] || { id:'id', vcelar:'vcelar', farma:'farma', kraj:'kraj', okres:'okres', obec:'obec', typy_medu:'typy_medu', vcelstva:'vcelstva', email:'email', telefon:'telefon' })
      const csv = [ header.join(','), ...rows.map(r => header.map(h => `"${String(r[h] ?? '').replace(/"/g,'""')}"`).join(',')) ].join('\n')
      const blob = new Blob([csv], { type:'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a'); a.href=url; a.download=`bee_dashboard_${new Date().toISOString().slice(0,10)}.csv`; a.click(); URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
/* KPIs */
.kpi-card { text-align:center; }
.kpi__label { font-size: 12px; opacity: .7; }
.kpi__value { font-size: 26px; font-weight: 700; line-height: 1.2; }

/* Charts */
.chart { width: 100%; height: 320px; }
.chart.large { height: 420px; }

/* Right filter panel (rovnaká logika ako ContentBase) */
.filter-side .ant-form-item { margin-bottom: 10px; }
.filter-card.filter-active { border: 2px solid #2d2d2d !important; }

.filter-side >>> .ant-form-item label
{line-height:1.2}
.ant-carousel .custom-slick-arrow:before
{display:none}
/* červený border okolo celého cardu, keď je aktívny filter */
.filter-side.filter-active,
.filter-card.filter-active {
  border: 3px solid #000000 !important;
  /* prípadne border-color: #000; pre čierny */
}
.chart-wrap { position: relative; overflow: hidden; }       /* odstrihne pretŕčajúci canvas */
.chart       { width: 100%; height: 320px; display: block; }

.chart.large { height: 420px; }

/* istota: schovaj overflow aj na tele Ant Cardu */
:deep(.ant-card-body),
>>> .ant-card-body { overflow: hidden; }

</style>
